<h3
  class="font-medium"
  (click)="selectSuggestedTerm($event)"
  (keydown)="keydownHandler($event)"
  [innerHTML]="header"
></h3>

<p class="font-medium color-ebony-a61" [innerHTML]="subtext"></p>
